{{#if hasUvcCoverage}}
virtual function bit has_coverage();
  return ({{ interfaceBoundVariable.identifier }} && {{ this.coverageEnabledVariable.identifier }});
endfunction
{{/if}}
